import { setLicenseKey } from "@grapecity/wijmo";

/**
 * Sets the license key that identifies licensed Wijmo applications, through @qubiteq/datagrid
 * @param licenseKey String containing the license key to use in this application.
 */
 export const licenseWj = (licenseKey: string) => {
    setLicenseKey(licenseKey);
}
